// Site Settings Configuration
export interface SiteSettings {
  show_logout_icon: number; // 1 = show, 0 = hide
  password_protection: number; // 1 = enabled, 0 = disabled
  site_title: string;
  company_name: string;
}

export const siteSettings: SiteSettings = {
  show_logout_icon: 0, // Set to 1 to show logout icon in navbar
  password_protection: 0, // Set to 1 to enable password protection
  site_title: 'Momentum Realty Group',
  company_name: 'Momentum Realty Group'
};

// Helper functions for easy access
export const shouldShowLogoutIcon = () => siteSettings.show_logout_icon === 1;
export const isPasswordProtectionEnabled = () => siteSettings.password_protection === 1;